import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import styled from 'styled-components';

import { UserInviteInput } from '../../../../../../../__generated__/globalTypes';

import { InviteFormLayout } from '../../../../../shared/invite';

import { User360InviteForFeedback, User360InviteForFeedbackVariables } from './__generated__/User360InviteForFeedback';
import { trimUrlLastPart } from '../../../../../shared/helper';

const PATH_USER_360_INVITE_LANDING = '/invite-sending';

const InviteFormLayoutFeedback360 = styled(InviteFormLayout)`
  margin-top: 20px;

  & .form-control:not(.is-invalid) {
    border: 1px solid #06061c;
  }
`;

const USER_360_INVITE = gql`
  mutation User360InviteForFeedback($input: UserInviteInput!) {
    user360Invite(input: $input) {
      id
    }
  }
`;

function Feedback360Form() {
  const history = useHistory();
  const routeMatch = useRouteMatch();

  const [user360Invite] = useMutation<User360InviteForFeedback, User360InviteForFeedbackVariables>(USER_360_INVITE);

  const onSubmit = (values: UserInviteInput) => {
    user360Invite({ variables: { input: values } }).then(() => {
      history.push(`${trimUrlLastPart(routeMatch.url)}${PATH_USER_360_INVITE_LANDING}`);
    });
  };

  return (
    <>
      <p>
        This is the place where you can share your Profyle with people who know you well and get their feedback. All you
        need to do is enter their name and email details below and Profyle will invite them.
        <br />
        You can add as many as you like, but typically people choose between 3 to 5 people. Most people chose a few
        colleagues, sometimes their boss and often their partner or best friend to get that valuable external view.
        <br />
        Each time one of your chosen people responds, Profyle will let you know.
      </p>

      <InviteFormLayoutFeedback360 onSubmit={onSubmit} />
    </>
  );
}

export { Feedback360Form };
